export const SEARCH_TYPES = ["Contact", "Company", "Note", "Document", "Task", "Opportunity", "Product/Service"];

export const PAGE_SIZE = 30;

const PRODUCT_SERVICE_ALIASES = ["Product Service", "Products/Services", "Product/Service"];

const CATEGORY_TO_TYPE = {
  contact: "Contact",
  company: "Company",
  note: "Note",
  document: "Document",
  task: "Task",
  opportunity: "Opportunity",
  product_service: "Product/Service",
  products_services: "Product/Service",
  "product/service": "Product/Service",
  "products/services": "Product/Service"
};

export const TYPE_TO_CATEGORY = {
  Contact: "contact",
  Company: "company",
  Note: "note",
  Document: "document",
  Task: "task",
  Opportunity: "opportunity",
  "Product/Service": "product_service"
};

const normalizeKey = (key = "") =>
  String(key)
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

export const normalizeType = (type) => {
  if (PRODUCT_SERVICE_ALIASES.includes(type)) return "Product/Service";
  return CATEGORY_TO_TYPE[normalizeKey(type)] || type;
};

export const typeToCategory = (type) => TYPE_TO_CATEGORY[normalizeType(type)] || normalizeKey(type);

export const normalizeModuleTotals = (moduleTotals = {}) => {
  return Object.entries(moduleTotals).reduce((acc, [key, value]) => {
    const type = normalizeType(key);
    acc[type] = (acc[type] || 0) + (parseInt(value, 10) || 0);
    return acc;
  }, {});
};

export const groupResultsByType = (list = []) => {
  return list.reduce((acc, item) => {
    const type = normalizeType(item.Type);
    if (!acc[type]) acc[type] = [];
    acc[type].push(item);
    return acc;
  }, {});
};

export const buildInternalSearchUrl = ({ search_value = "", limit = PAGE_SIZE, offset = 0, category } = {}) => {
  const params = new URLSearchParams({
    full: "true",
    schema: "internal",
    search: search_value,
    limit: String(limit),
    offset: String(offset)
  });
  if (category) params.set("category", category);
  return `tenantUser/search?${params.toString()}`;
};
